
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {FuseSidebarModule} from "../../../@fuse/components";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {MatRippleModule} from "@angular/material/core";
import {TranslateModule} from "@ngx-translate/core";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatTreeModule} from "@angular/material/tree";
import {LogComponent} from "./log.component";
import {DetailsDialogComponent} from "./dialog/details.component";

@NgModule({
    declarations: [
        LogComponent,
        DetailsDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,
        MatToolbarModule,
        MatDialogModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatTreeModule

    ],
    providers: [

    ],
    exports: [

    ],
    bootstrap: [
        LogComponent,
    ]
})
export class LogModule { }
